const $ = window.jQuery;
//import "select2";

const $DOM = {};

const domCache = () => {
    $DOM.select = $(".select-container");
}

const initSelect = {
    init: () => {
        domCache();
        if(!$DOM.select.length) {
            return;
        }
        $DOM.select.select2({
                minimumResultsForSearch: Infinity
        });
    }
};

export default initSelect;